<div #autocomplete class="autocomplete" [ngClass]="classeModeApplication">
	<ng-template #template let-result="result" let-t="term">
		<ngb-highlight *ngIf="!searching" [result]="resultFormatter ? resultFormatter(result) : formatter(result)" [term]="t"></ngb-highlight>
	</ng-template>
	<div class="input">
		<div class="d-flex">
			<input [id]="inputId ? inputId : null"
				   [focusFirst]="strict"
				   [disabled]="disabled"
				   (blur)="onBlur()"
				   type="text"
				   class="form-control form-control-sm"
				   [ngClass]="classInput"
				   [editable]="!strict"
				   [(ngModel)]="model"
				   (focus)="openOnFocus($event.target)"
				   (ngModelChange)="change($event)"
				   [inputFormatter]="inputFormatter ? inputFormatter : formatter"
				   [resultFormatter]="resultFormatter ? resultFormatter : formatter"
				   [ngbTypeahead]="search"
				   [container]="appendTo"
				   [placeholder]="placeholder"
				   [resultTemplate]="template"
				   [placement]="placement"
				   [maxlength]="maxlength ? maxlength : 524288"
			/>
			<span *ngIf="searching && loaderInput" class="spinner-menu-input border rounded w-100">
				<span class="app-spinner"></span>
			</span>
			<button id="btn-vider-autocomplete"
					[style.visibility]="disabled?'hidden':autocomplete.style.visibility"
					[disabled]="disabled"
					tabindex="-1"
					type="button"
					class="btn btn-link text-dark clear"
					(click)="clearItem()">
				<span class="fas fa-times"></span>
			</button>
		</div>
	</div>
	<span *ngIf="searching" class="spinner-menu border rounded w-100">
    <span class="app-spinner m-2"></span>
  </span>
</div>
